import React from 'react';
import { Trans } from 'react-i18next';

import { CheckboxRounded } from '@/components/CheckboxRounded';
import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { Product, useJurisdictionStore } from '@/hooks/use-jurisdiction';
import { ParseKeys } from 'i18next';

import { useOpenTermsLink } from '../hooks/use-open-terms-link';

const PRODUCT_TNC_KEY: Partial<Record<Product, ParseKeys<'terms_and_conditions'>>> = {
    [Product.Pickem]: 'pickem_product_tnc',
    [Product.Sweeps]: 'sweeps_product_tnc',
    [Product.Arcade]: 'arcade_product_tnc',
    [Product.Casino]: 'casino_product_tnc',
    [Product.Rips]: 'rips_product_tnc',
};

/**
 * A component to display the Terms and Conditions checkbox for a specific product.
 */
export const ProductTncCheckbox = ({
    value,
    toggleValue,
    onWebViewOpened,
}: {
    value: boolean;
    toggleValue: () => void;
    onWebViewOpened?: () => void;
}) => {
    const product = useJurisdictionStore(state => state.product);
    const openTermsLink = useOpenTermsLink(onWebViewOpened);

    const i18nKey = PRODUCT_TNC_KEY[product];

    if (!i18nKey) {
        return null;
    }

    return (
        <Row
            p="s16"
            alignItems="center"
            mt="s8"
            borderRadius="r16"
            backgroundColor={ds.colorToken.background.neutral.subtler}
        >
            <Box mr="s16">
                <CheckboxRounded value={value} setValue={toggleValue} />
            </Box>
            <Box flex={1}>
                <Text>
                    <Trans i18nKey={i18nKey} ns="terms_and_conditions">
                        I accept the
                        <Text
                            textDecorationLine="underline"
                            color={ds.colorToken.text.brand}
                            lineHeight={19}
                            onPress={openTermsLink}
                        />
                    </Trans>
                </Text>
            </Box>
        </Row>
    );
};
